/* template */
<template minapp="mpx" xlang="wxml"><mpx-view :style="[({flexDirection: direction})] | transRpxStyle" @tap="containerTap" class="es-container" :class='[$attrs["custom-class"]]'><slot name="bg-icon"></slot><div class="es-header" v-if="(slot.header)"><es-navbar custom-title="custom-title" :style="[(navbarStyle)] | transRpxStyle" :on-click-left="(navbarClickLeft)" :left-arrow="(leftArrow)" :use-web-back="(navbarUseWebBack)" class="es-header__navbar" :custom-class='["custom-navbar"].join(" ")' v-if="(title)">{{ title }}<div slot="right" v-if="(useRight)"><slot name="right"/></div></es-navbar><slot name="header"></slot></div><mpx-view :style="[(esMainStyle)] | transRpxStyle" @scroll="handleScroll" class="es-main custom-main"><blank-page :type="(blankPageType)" :loadingContext="(loadingContext)" :blankButtonContext="(blankButtonContext)" :blankContextTitle="(blankContextTitle)" :blankContextSubTitle="(blankContextSubTitle)" :loadingImageUrl="(loadingImageUrl)" :blankImageUrl="(blankImageUrl)" :hasButton="(hasBlankButton)" :hasSubTitle="(hasBlankSubTitle)" :hasTitle="(hasBlankTitle)" :setBlankContext="(setBlankContext)" :blank-title-style="(blankTitleStyle)" :blank-subtitle-style="(blankSubtitleStyle)" :categoryLoadingTitle="(categoryLoadingTitle)" :categoryLoadingDesc="(categoryLoadingDesc)" @click-button="clickButton" v-if="(useBlankPage)"><div slot="blankContextTitle"><slot name="blankContext"/></div></blank-page><slot v-else></slot></mpx-view><div class="es-footer" v-if="(slot.footer)"><slot name="footer-tips"></slot><slot name="footer"></slot></div></mpx-view></template>

/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"m2146c876"}'>
  @import '../common/style/bem'

  +b('container')
    display flex
    height 100%
    flex 1
    flex-basis auto
    box-sizing border-box
    min-width 0
  +b('header')
    display flex
    flex-direction column
  +b('main')
    flex 1
    overflow-y auto
    background #eee
  +b('footer')
    display flex
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2146c876"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2146c876%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2146c876%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2146c876"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2146c876/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-navbar':getComponent(require("../navbar/index.mpx?isComponent&outputPath=components%2Findex2c95552b%2Findex")),'blank-page':getComponent(require("../blank-page/index.mpx?isComponent&outputPath=components%2Findex4a5ffbfa%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
